module.exports = __webpack_public_path__ + "static/media/Nota Regalos con té .076228a7.webp";